<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存明细</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">

      <!-- 月度出入库报表 strat -->
      <el-tab-pane label="月度出入库报表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywordsMonthly" ref="keywordsMonthlyRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywordsMonthly.shangpinfenlei" @keyup.enter.native="clickMonthlySearch" placeholder="请输入商品分类"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywordsMonthly.shangpinname" @keyup.enter.native="clickMonthlySearch" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickMonthlySearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataListMonthly" border :cell-style="{padding: '0'}" height="440">
          <el-table-column prop="Shangpinfenlei" label="商品分类" width="100"></el-table-column>
          <el-table-column prop="Shangpinname" label="商品名称" width="200"></el-table-column>
          <el-table-column prop="Shangpincode" label="商品编码" width="200"></el-table-column>
          <el-table-column prop="Shangpinguige" label="商品规格" width="400"></el-table-column>
          <el-table-column prop="Shangpinunit" label="单位" width="100"></el-table-column>
          <el-table-column prop="InMonthlyNum" label="本月入库数量" width="120"></el-table-column>
          <el-table-column prop="OutMonthlyNum" label="本月出库数量" width="120"></el-table-column>
          <el-table-column prop="RealTimeNum" label="库存数量" width="100"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleMonthlyCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListMonthlynum"
            :current-page.sync="selectedPageNoMonthly">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 月度出入库报表 end -->

      <!-- 库存明细 strat -->
      <el-tab-pane label="库存明细" name="second">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="统计日期">
            <el-date-picker v-model="keywords.riqi" type="date" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
<!--          <el-form-item label="">
            <el-input v-model="keywords.shangpinfenlei" @keyup.enter.native="clickSearch" placeholder="请输入商品分类"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.shangpinname" @keyup.enter.native="clickSearch" placeholder="请输入商品名称"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column prop="Shangpinfenlei" label="商品分类" width="100"></el-table-column>
          <el-table-column prop="Shangpinname" label="商品名称" width="200"></el-table-column>
          <el-table-column prop="Shangpincode" label="商品编码" width="200"></el-table-column>
          <el-table-column prop="Shangpinguige" label="商品规格" width="300"></el-table-column>
          <el-table-column prop="Shangpinunit" label="单位" width="100"></el-table-column>
          <el-table-column prop="YueChuJieYuShu" label="月初结余数" width="100"></el-table-column>
          <el-table-column prop="BenYueRuKuShu" label="本月入库数" width="100"></el-table-column>
          <el-table-column prop="BenYueChuKuShu" label="本月出库数" width="100"></el-table-column>
          <el-table-column prop="YueMoJieYuShu" label="月末结余数" width="100"></el-table-column>
          <el-table-column prop="ZuiDiAnQuanShu" label="最低安全库存量" width="100"></el-table-column>
          <el-table-column prop="BaoJing" label="存货预警" width="100"></el-table-column>
          <el-table-column prop="operation" label="操作" width="120" fixed="right">
            <template v-slot="scope">
              <el-button v-if="scope.row.BaoJing == '预警'" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goToCaiGou(scope.row)">去采购</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 库存明细 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyErp6InventoryDetails',
  data () {
    return {
      activeName: 'first',
      // 库存明细
      keywords: {
        shangpinfenlei: '',
        shangpinname: '',
        riqi: '',
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      // 月度出入库报表
      keywordsMonthly: {
        shangpinfenlei: '',
        shangpinname: ''
      },
      dataListMonthly: [],
      dataListMonthlynum: 0,
      selectedPageNoMonthly: 1
    }
  },
  mounted () {
    this.keywords.riqi = Vue.prototype.FunGetTimeStringShort()
    //月度出入库报表
    this.apiGetErp6InventoryMonthlyNum()
    this.apiGetErp6InventoryMonthlyList()
    //库存明细
    this.apiGetErp6InventoryDetailsNum()
    this.apiGetErp6InventoryDetailsList()
  },
  methods: {
    //月度出入库报表
    clickMonthlySearch () {
      this.selectedPageNoMonthly = 1
      this.apiGetErp6InventoryMonthlyNum()
      this.apiGetErp6InventoryMonthlyList()
    },
    handleMonthlyCurrentPageChange (selectedPageNo) {
      this.apiGetErp6InventoryMonthlyList()
    },
    //库存明细
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6InventoryDetailsNum()
      this.apiGetErp6InventoryDetailsList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6InventoryDetailsList()
    },
    BackToSecond (val) {
      this.activeName = 'second'
      this.apiGetErp6InventoryDetailsNum()
      this.apiGetErp6InventoryDetailsList()
    },
    //
    goToCaiGou (row) {
      localStorage.setItem("gotopath","/Erp6PurchaseOrder");
      localStorage.setItem("gotopathname","采购订单");
      const routeData = this.$router.resolve({ path: '/Erp6PurchaseOrder' });
      window.open(routeData.href, '_blank');
    },
    clickReturn () {
      this.activeName = 'first'
    },
    // 月度出入库报表
    apiGetErp6InventoryMonthlyNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywordsMonthly }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6InventoryMonthlyNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListMonthlynum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    // 月度出入库报表
    apiGetErp6InventoryMonthlyList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNoMonthly
      }
      data = { ...data, ...that.keywordsMonthly }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6InventoryMonthlyList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListMonthly = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    // 库存明细
    apiGetErp6InventoryDetailsNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6InventoryDetailsNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    // 库存明细
    apiGetErp6InventoryDetailsList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6InventoryDetailsList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
